import { useState } from "react";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from "recharts";
import styles from "./AiInsight.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const AiInsight = () => {
    const [revenue, setRevenue] = useState("");
    const [showInsight, setShowInsight] = useState(false);

    const handleView = () => {
        if (revenue) {
            setShowInsight(true);
        }
    };

    // Dữ liệu mẫu để test
    const data = [
        { name: "Doanh thu", value: 267142292 },
        { name: "Chi phí quảng cáo", value: 24500000 },
    ];

    const COLORS = [
        "url(#colorRevenue)",
        "url(#colorCost)"
    ];

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="#fff"
                textAnchor="middle"
                dominantBaseline="central"
                fontSize={12}
                fontWeight="600"
            >
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    }; 
    return (
        <div className={cx("panel", "ai-note")}>
            <h4>AI nhận xét</h4>
            {!showInsight ? (
                <div className={cx("inputRow")}>
                    <input
                        type="number"
                        placeholder="Nhập doanh thu..."
                        value={revenue}
                        onChange={(e) => setRevenue(e.target.value)}
                    />
                    <button className={cx("btn")} onClick={handleView}>
                        Xem
                    </button>
                </div>
            ) : (
                <div className={cx("insightContent")}>
                    <div className={cx("revenueInfo")}>
                        <span className={cx("label")}>Doanh thu:</span>
                        <span className={cx("value")}>
                            {parseInt(revenue || 0).toLocaleString("vi-VN")} đ
                        </span>
                    </div>

                    {/* Biểu đồ hiện đại hơn */}
                    <div className={cx("chartRow")}>
                        <ResponsiveContainer width="100%" height={260}>
                            <PieChart>
                                <defs>
                                    <linearGradient id="colorRevenue" x1="0" y1="0" x2="1" y2="1">
                                        <stop offset="5%" stopColor="#4facfe" stopOpacity={0.9} />
                                        <stop offset="95%" stopColor="#00f2fe" stopOpacity={0.9} />
                                    </linearGradient>
                                    <linearGradient id="colorCost" x1="0" y1="0" x2="1" y2="1">
                                        <stop offset="5%" stopColor="#ff6a00" stopOpacity={0.9} />
                                        <stop offset="95%" stopColor="#ee0979" stopOpacity={0.9} />
                                    </linearGradient>
                                </defs>

                                <Pie
                                    data={data}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={70}
                                    outerRadius={100}
                                    paddingAngle={3}
                                    dataKey="value"
                                    labelLine={false}
                                    label={renderCustomizedLabel}
                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                    ))}
                                </Pie>
                                <Tooltip
                                    contentStyle={{ borderRadius: "8px", fontSize: "13px" }}
                                />
                                <Legend verticalAlign="bottom" height={36} />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>


                    <div className={cx("comments")}>
                        <ul>
                            <li>
                                Facebook là kênh mạnh nhất, chiếm hơn 64% lượt hiển thị và gần 63%
                                lượt tương tác, với hiệu quả cao nhất về đánh giá khách hàng.
                            </li>
                            <li>Zalo đứng thứ hai, hiệu suất tốt, chi phí hợp lý.</li>
                            <li>
                                TikTok có chi phí thấp nhưng vẫn giữ lượng tương tác ổn định, chứng
                                tỏ tiềm năng tiếp cận nhóm khách hàng trẻ.
                            </li>
                            <li>
                                Biểu đồ cho thấy phần doanh thu chiếm áp đảo, trong khi chi phí
                                quảng cáo rất nhỏ, ROI cao.
                            </li>
                            <li>
                                Xu hướng tăng trưởng tích cực ở lượt hiển thị, tương tác và đánh giá,
                                đặc biệt là việc giảm chi phí vẫn duy trì hiệu quả.
                            </li>
                        </ul>

                        <h5>Kết luận & Đề xuất:</h5>
                        <ul>
                            <li>Chiến dịch hiện tại đang hoạt động hiệu quả vượt mong đợi.</li>
                            <li>
                                Nên tiếp tục đầu tư mạnh vào Facebook và mở rộng chiến dịch trên
                                TikTok.
                            </li>
                            <li>
                                Khuyến khích duy trì xu hướng giảm chi phí - tăng hiệu quả, đồng thời
                                thử nghiệm thêm các định dạng nội dung mới.
                            </li>
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AiInsight;
